module.exports = __webpack_public_path__ + "img/B6.f8c9d0d8.svg";